'use strict';

function AlbumPhotosController($rootScope, $scope, objectMakerFactory, dataHolderFactory, dataRequestService, usSpinnerService) {
  var self = this;

  this.getAlbumPhotos = function () {
    $scope.albumPhotosControl.mapAlbumPhotos = dataHolderFactory.getMapAlbumPhotos();
    $scope.albumPhotosControl.albumMonths = Object.keys($scope.albumPhotosControl.mapAlbumPhotos);
  };

  $scope.initAlbumPhotosController = function () {
    $scope.albumPhotosControl = objectMakerFactory.viewObjectControlForAlbumPhotos();
    self.getAlbumPhotos();
  };

  $scope.restoreViewControl = function () {
    $rootScope.appControl.showAlbumBox = false;
  };

  $scope.showPhotos = function (albumId) {
    if($rootScope.appControl.showAlbumBoxDetails) {
      return;
    }
    dataHolderFactory.updateAlbumPhotoId(albumId);
    $rootScope.appControl.showAlbumBoxDetails = true;
  };
}

AlbumPhotosController.$inject = ['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'usSpinnerService']
export default AlbumPhotosController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/albumPhotosController.js